import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToggleColorInterconnection = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 18 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M9 13.5C11.4767 13.5 13.5 11.4144 13.5 8.86206C13.5 5.77972 9 0.75 9 0.75C9 0.75 4.5 5.77972 4.5 8.86206C4.5 11.4144 6.5233 13.5 9 13.5Z" }), /* @__PURE__ */ _jsx("path", { d: "M1.65 15H16.35C16.4325 15 16.5 15.0563 16.5 15.125V16.375C16.5 16.4437 16.4325 16.5 16.35 16.5H1.65C1.5675 16.5 1.5 16.4437 1.5 16.375V15.125C1.5 15.0563 1.5675 15 1.65 15Z" })]
});
export default SvgToggleColorInterconnection;
